import { createFileRoute, redirect } from '@tanstack/react-router'
import { CountSheetScreen } from '@/features/inventory-counts/count-sheet-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/counts/$sessionId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_count.view'))
      throw redirect({ to: '/inventory/counts' })
  },
  component: CountSheetRoute,
})

function CountSheetRoute() {
  const { sessionId } = Route.useParams()

  return <CountSheetScreen sessionId={sessionId} />
}
